<script>
export let messages;


import Message from './Message.svelte';

</script>


<style>

#flash-holder {
	width: 410px;
	position: sticky;
	bottom: 24px;
	left: 24px;
}

</style>


<div id="flash-holder">

	<!-- <Message />
	<Message />
	<Message />
	<Message />
	<Message /> -->

	{#each messages as message}
		<Message {message} />
	{/each}

</div>
